<template>
	<div class="flex w-full min-h-screen bg-img vx-row no-gutter items-center justify-center absolute registration-page" id="page-login">
		<div
			:class="{
				'lg:w-3/4 xl:w-3/5': !$store.getters.isClientUrl,
				'lg:w-2/4 xl:w-2/5 max-w-md': $store.getters.isClientUrl,
			 }"
			class="vx-col m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">

					<div class="vx-row no-gutter justify-center items-center">

						<img
							v-if="!$store.getters.isClientUrl"
							src="@/assets/images/pages/login.png"
							alt="login"
							class="mx-auto hidden lg:block"
						>

						<div
							:class="{ 'lg:w-1/2': !$store.getters.isClientUrl }"
							class="vx-col sm:w-full md:w-full d-theme-dark-bg"
						>
							<div class="px-8 pt-8 login-tabs-container">

								<div class="vx-card__title mb-4">
									<h4 class="mb-4"><b>{{ $t('registration') }}</b></h4>
									<p>{{ $t('fillFormBelowToCreateNewAccount') }}</p>
								</div>
								<component
									:is="$route.path.slice(1)"
									:key="$store.getters.getLayout"
                  :loading="loading"
									@register="register"
								></component>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>


<script>
import register from '../../components/auth/registerClient'
import registrationAuthor from '../../components/auth/registerAuthor'
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	components: {
		register,
		registrationAuthor
	},

  data() {
    return {
      loading: false,
    }
  },

	methods: {
		checkLogin() {
			// If user is already logged in notify
			if (this.$store.getters.isLoggedIn) {

				// Close animation if passed as payload
				// this.$vs.loading.close()

				this.notifyError(this.$t('youAreAlreadyLoggedIn'));
				return false;
			}

			return true;
		},
		async register(formData, photo) {

			// if (!this.checkLogin()) return

			// // Loading
			// this.$vs.loading()

			try	{
        this.loading = true
				let res = await this.$store.dispatch('register', {
					formData,url: this.$route.path,
					photo
				});

				this.$vs.loading.close()
				setTimeout(()=>{
					this.$router.push('/');
				}, 1000)
			} catch(error) {
				this.$vs.notify({
					title: 'Error',
					text: this.formattedError(error),
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
				this.$vs.loading.close()
			} finally {
        this.loading = false
      }
		},
    formattedError(error) {
      const errorsArray = []
      errorsArray.push(error.message)

      if (!!error.errors) {
        for (let er in error.errors) {
          error.errors[er].map(el => {
            errorsArray.push(el)
          })
        }
      }
      return errorsArray.join(' ')
    }
	}
}
</script>

<style lang="scss">
.login-tabs-container {
	min-height: 400px;
	color: #626262;

	.center {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.vs-con-input-label {
		width: 100%;
	}

	.form-input {
		margin-bottom: 14px;
		position: relative;
		width: 48%;
	}

	.text-danger {
		bottom: -5px;
		padding-left: 5px;
	}

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}

.registration-page {
	&__logo {
		max-width: 90%;
		max-height: 90%;
	}
}
</style>
